<template>
	<el-dialog title="定价辅助计算器" :visible.sync="dialogVisible" :modal-append-to-body="false" append-to-body width="1200px"
		top="6vh">
		<el-form :model="ruleForm" ref="ruleForm" label-width="100px" size="medium">
			<div style="display: flex;width: 100%;padding: 0 10px;margin-bottom: 15px">
				<div class="item_title">
					采购成本
				</div>
				<div class="item_title">
					平台成本
				</div>
				<div class="item_title">
					广告促销
				</div>
			</div>
			<div class="form_box">
				<div class="item_box_form">
					<el-form-item label="采购单价：" prop="caigoudanjia">
						<el-input v-model="ruleForm.caigoudanjia" class="item_input"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">CNY</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="类目佣金：">
						<el-select v-model="ruleForm.leimuyongjin" placeholder="请选择" filterable @change="changeYongjin"
							style="width: 100%">
							<el-option v-for="item in yongjinOptions" :key="item.id" :label="item.label"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="广告：" prop="guanggao">
						<el-input v-model="ruleForm.guanggao"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="采购运费：">
						<el-input v-model="ruleForm.caigouyunfei" class="item_input"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">CNY</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="提现手续：" prop="tixianshouxu">
						<el-input v-model="ruleForm.tixianshouxu" disabled>
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="促销活动：" prop="cuxiaohuodong">
						<el-input v-model="ruleForm.cuxiaohuodong"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
				</div>
			</div>
			<div style="display: flex;width: 100%;padding: 0 10px;margin-bottom: 15px">
				<div class="item_title">
					国际运费
				</div>
			</div>
			<div class="form_box">
				<div class="item_box_form">
					<el-form-item label="重量：" prop="zhongliang">
						<el-select v-model="ruleForm.zhongliang" filterable placeholder="请选择" @change="changeZhongliang"
							clearable style="width: 100%">
							<el-option v-for="item5 in zhongliangOptions" :key="item5.id" :label="item5.weight"
								:value="item5.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="净利率：" prop="jinglilv">
						<el-input v-model="ruleForm.jinglilv" class="item_input"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
				</div>
				<div class="item_box_form">
					<el-form-item label="预估运费：" prop="yuguyunfei">
						<el-input v-model="ruleForm.yuguyunfei"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">USD</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-form-item label="售价：" prop="shoujia">
						<el-input v-model="ruleForm.shoujiaCurreny"
							oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
							<template slot="append">{{ shoujiaCurreny }}</template>
						</el-input>
					</el-form-item>
				</div>
				<div class="item_box_form">
					<el-button type="primary" @click="jisuan">计 算</el-button>
				</div>
			</div>

			<div style="display: flex;width: 100%;padding: 0 10px;margin-bottom: 15px">
				<div class="item_title">
					计算过程
				</div>
			</div>
			<el-input class="input_area" type="textarea" :rows="5" v-model="ruleForm.beizhuguocheng" />
		</el-form>
		<span slot="footer" style="margin-top: 60px">
			<el-button type="primary" v-if="isshowBeizhu" @click="beizhu">备注过程</el-button>
			<el-button type="primary" @click="gengxinshoujia">更新售价</el-button>
			<el-button @click="dialogVisible = false">关 闭</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { ajaxPost, Baseurl, ajaxGet } from '@/api/api/api'
export default {
	name: 'dingjiaComp',
	props: {
		// score: {
		// 	type: Array,
		// 	default() {
		// 		return [0,0,0,0];
		// 	},
		// }
	},
	data() {
		return {
			//是否展示备注按钮
			isshowBeizhu: true,
			shoujiaCurreny: '',
			yongjinOptions: [],
			zhongliangOptions: [],
			//问号图标的地址
			urlQueImg: require('@/assets/images/wenhao.png'),
			//提示bug弹窗
			dialogVisible: false,
			meiyuanhuilv: 7.14,
			ruleForm: {
				caigoudanjia: '',
				leimuyongjin: '',
				guanggao: 9,
				caigouyunfei: '',
				tixianshouxu: 0.7,
				cuxiaohuodong: 15,
				zhongliang: '',
				jinglilv: 20,
				yuguyunfei: '',
				shoujia: '',
				beizhuguocheng: ''
			},
			commission: undefined
		}
	},
	created() {
		//获取分类重量运费列表
		const API = Baseurl + 'ozonWeightFreightController/getOzonWeightFreightList'
		ajaxGet(API).then((res) => {
			const { code, data } = res.data
			if (code === 200) {
				this.zhongliangOptions = data
			}
		})
		//获取佣金比例列表
		const API2 = Baseurl + 'ozonCategoryCommissionRateController/getOzonCategoryCommissionRateList'
		ajaxGet(API2).then((res) => {
			const { code, data } = res.data
			if (code === 200) {
				let yongjinOptions = data.map(item => {
					item.label = item.categoryGroup + '_' + item.category + ' ' + item.commission
					item.value = item.id
					return item
				})
				this.yongjinOptions = yongjinOptions
			}
		})
	},
	methods: {
		getHuilv() {
			const API = Baseurl + 'rateController/getRateByCurrencyCode'
			let params = {
				currencyCode: this.shoujiaCurreny
			}
			ajaxPost(API, params).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.meiyuanhuilv = parseFloat(data.exchangeRate)
				}
			})
		},
		//重置定价
		resetDingjia() {
			this.ruleForm = {
				shoujiaCurreny:'',
				caigoudanjia: '',
				leimuyongjin: '',
				guanggao: 9,
				caigouyunfei: '',
				tixianshouxu: 0.7,
				cuxiaohuodong: 15,
				zhongliang: '',
				jinglilv: 20,
				yuguyunfei: '',
				shoujia: '',
				beizhuguocheng: ''
			}
		},
		changeYongjin(val) {
			if (val) {
				this.commission = this.yongjinOptions.filter(item => {
					return item.id == val
				})[0].commission
			}
		},
		changeZhongliang(val) {
			//给预估费用赋值
			this.ruleForm.yuguyunfei = this.zhongliangOptions.filter(item => {
				return item.id == val
			})[0].freight

		},
		jisuan() {
			let caigoudanjia = this.ruleForm.caigoudanjia ? this.ruleForm.caigoudanjia : 0
			let leimuyongjin = this.commission ? this.commission : 0
			let guanggao = this.ruleForm.guanggao ? this.ruleForm.guanggao : 0
			let caigouyunfei = this.ruleForm.caigouyunfei ? this.ruleForm.caigouyunfei : 0
			let tixianshouxu = this.ruleForm.tixianshouxu ? this.ruleForm.tixianshouxu : 0
			let cuxiaohuodong = this.ruleForm.cuxiaohuodong ? this.ruleForm.cuxiaohuodong : 0
			let jinglilv = this.ruleForm.jinglilv ? this.ruleForm.jinglilv : 0
			let yuguyunfei = this.ruleForm.yuguyunfei ? this.ruleForm.yuguyunfei : 0
			this.ruleForm.shoujia = parseFloat((caigoudanjia / 1 + caigouyunfei / 1 + (yuguyunfei * this.meiyuanhuilv)) /
				(1 - (leimuyongjin / 100) - (tixianshouxu / 100) - (guanggao / 100) - (cuxiaohuodong / 100) - (jinglilv / 100)) / this.meiyuanhuilv).toFixed(2)

			this.ruleForm.beizhuguocheng =
				(this.ruleForm.shoujia ? this.ruleForm.shoujia : 0) + 'CNY = (' + (this.ruleForm.caigoudanjia ? this.ruleForm.caigoudanjia : 0) + ' + ' + (this.ruleForm.caigouyunfei ? this.ruleForm.caigouyunfei : 0) + ' + ' + (this.ruleForm.yuguyunfei ? this.ruleForm.yuguyunfei : 0)
				+ ' * ' + this.meiyuanhuilv + ')  / (1 - ' + leimuyongjin / 100 + ' - ' + (this.ruleForm.guanggao ? this.ruleForm.guanggao : 0) / 100 + ' - 0.007' + ' - ' +
				(this.ruleForm.cuxiaohuodong ? this.ruleForm.cuxiaohuodong : 0) / 100 + ' - ' + (this.ruleForm.jinglilv ? this.ruleForm.jinglilv : 0) / 100 + ')' + ' / ' + this.meiyuanhuilv + '\n' +
				'售价 =（采购单价 + 采购运费 + 国际运费 * 汇率） / （1 - 类目佣金 - 提现手续费 - 广告 - 促销 - 净利率）/ 汇率\n' +
				'采购单价 = ' + (this.ruleForm.caigoudanjia ? this.ruleForm.caigoudanjia : 0) + 'CNY\n' +
				'采购运费 = ' + (this.ruleForm.caigouyunfei ? this.ruleForm.caigouyunfei : 0) + 'CNY\n' +
				'国际运费 = ' + (this.ruleForm.yuguyunfei ? this.ruleForm.yuguyunfei : 0) + 'USD\n' +
				'汇率 = ' + (this.meiyuanhuilv ? this.meiyuanhuilv : 0) + '\n' +
				'类目佣金 = ' + leimuyongjin + 'CNY\n' +
				'广告 = ' + (this.ruleForm.guanggao ? this.ruleForm.guanggao : 0) + 'CNY\n' +
				'促销 = ' + (this.ruleForm.cuxiaohuodong ? this.ruleForm.cuxiaohuodong : 0) + 'CNY\n' +
				'净利率 = ' + (this.ruleForm.jinglilv ? this.ruleForm.jinglilv : 0) + 'CNY\n' +
				'售价 = ' + (this.ruleForm.shoujia ? this.ruleForm.shoujia : 0) + 'CNY\n' +
				'售价 = ' + Number((this.ruleForm.shoujia ? this.ruleForm.shoujia : 0) / this.meiyuanhuilv).toFixed(2) + this.shoujiaCurreny
			this.ruleForm.shoujiaCurreny = Number((this.ruleForm.shoujia ? this.ruleForm.shoujia : 0) / this.meiyuanhuilv).toFixed(2)
		},
		//备注过程
		beizhu() {
			this.$emit('changeReamrk', this.ruleForm.beizhuguocheng)
		},
		//更新售价
		gengxinshoujia() {
			if (!this.ruleForm.shoujia) {
				this.jisuan()
			}
			this.$emit('changeDingjia', this.ruleForm.shoujiaCurreny)
			this.dialogVisible = false
		}
	}
}
</script>
<style lang="scss" scoped>
@import "../walmart.less";

/deep/ .el-input-group__append {
	width: 50px;
	text-align: center;
	padding: 0 0;
}

/deep/ .el-form-item__label {
	font-size: 18px;
}

.form_box {
	display: flex;
	width: 100%;
	flex-wrap: wrap;

	.item_box_form {
		width: calc(33% - 30px);
		padding-right: 30px;
	}
}

.item_title {
	width: 33%;
	border-left: 5px solid rgb(95, 175, 255);
	padding-left: 10px;
	font-size: 18px;
}

.input_area {
	width: calc(99% - 60px);
	margin-left: 30px;
	margin-top: 20px;
}
</style>
